import axios from "axios";
import { _getBaseUrl } from "./helper.jsx";

const restURL = `${_getBaseUrl()}api`;

// export const accesspassBaseURL = () => {
//   return "https://accesspass.io";
// }

export const accesspassBaseURL = () => {
  const host = window.location.hostname;

  // production
  // if (host.endsWith(".nl")) {
  return "https://accesspass.io";
  // }

  // staging + dev
  // return "https://staging.accesspass.io";
};


export const apiToken = () => {
  return "eyJpdiI6IkRpcng1ZEtDZkNEMmNTdERpa0Z0Z0E9PSIsInZhbHVlIjoiMGh3cWQxdXRUMFhOc2thR1VnM1VvNngwR1YvZzR2dWsrc1ZINGlCUUlTUT0iLCJtYWMiOiIzNDBmOTQ5NWEzNDlhMDc0M2NjZTRhMzVmMWEzYmE3ZDk1OTgyMDIxMGI1ZjcxOGVhZTMwM2ZlZjBjM2E4NGM3IiwidGFnIjoiIn0=";
};


const api = axios.create({
  baseURL: restURL,
});

api.interceptors.request.use(
  function (config) {
    config.headers["Content-Type"] = "application/json";
    // console.log(`Request, ${config.url}`, config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // console.log("Response", response);
    return response;
  },
  (error) => {
    console.log("Error", error.response);
    return Promise.reject(error.response);
  }
);

export default api;
